// Brand mark: Eli's MentorAI logo (head silhouette of charts + cash), served from /public.
export const LogoMark = ({ className = "size-8" }) => (
  <img
    src="/logo-128.png"
    srcSet="/logo-64.png 64w, /logo-128.png 128w, /logo-256.png 256w"
    sizes="64px"
    alt="MentorAI logo"
    width="32"
    height="32"
    draggable="false"
    className={`shrink-0 rounded-lg bg-white object-cover ring-1 ring-black/10 dark:ring-white/15 shadow-sm ${className}`}
  />
);

export const Logo = ({ className = "", dark = false, markClassName = "size-8" }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>
    <LogoMark className={`${markClassName} ${dark ? "ring-white/15" : ""}`} />
    <span className={`font-display text-lg font-semibold tracking-tight ${dark ? "text-white" : "text-foreground"}`}>
      Mentor<span className="text-brand">AI</span>
    </span>
  </div>
);
